import { AddressDetailsModel } from '../../store/state/address/models/address.model';
import { AddressModel } from '../models';

export const transformAddressDetailsIntoModel = (addressDetailsList: AddressDetailsModel[]): AddressModel[] => {
  const addressDetailsModels = addressDetailsList
    .map((addressModel: AddressDetailsModel) => new AddressDetailsModel(addressModel))
    .sort((a: AddressDetailsModel, b: AddressDetailsModel) => a.fullAddress.localeCompare(b.fullAddress));

  return addressDetailsModels.map(addressDetailToAddressModel);
};

export const addressDetailToAddressModel = (addressDetail: AddressDetailsModel): AddressModel =>
  new AddressModel({
    addressExtId: addressDetail.extId,
    name: addressDetail.name,
    fullAddress: addressDetail.fullAddress,
  });

export const addressModelTypeGuard = (address: AddressModel | AddressDetailsModel): address is AddressModel => {
  return (address as AddressModel)?.addressExtId !== undefined;
};

export const addressDetailsModelTypeGuard = (
  address: AddressModel | AddressDetailsModel,
): address is AddressDetailsModel => {
  return (address as AddressDetailsModel)?.extId !== undefined;
};

export const addressModelIsArrayTypeGuard = (address: AddressModel | AddressModel[]): address is AddressModel[] => {
  return (address as AddressModel[])?.length !== undefined;
};
